// React for Website

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
//outsource
import { Row, Col, Segmented, Button, DatePicker } from "antd";

//components
import SearchVoucher from "./component/search_voucher";
import VoucherList from "./component/voucher_list";
import DialogSendVoucher from "./dialog/dialog_send_voucher";
import DialogVoucherDetail from "./dialog/dialog_voucher_detail";
import moment from "moment";
import { VOUCHER_STATUS } from "../../store/string";

//redux
import { useDispatch, useSelector } from "react-redux";
import {
  snapVouchersByPackageId,
  unSnapVoucher,
} from "../../store/voucher/voucher.action";
import { vouchersSelector } from "../../store/voucher/voucher.selector";
import { userSelector } from "../../store/user/user.selector";

import "./style.css";

const { RangePicker } = DatePicker;

const SectionSearch = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const packageId = params.packageId || "";
  const branchId = params.id || "";
  // -------------------------- STATE --------------------------
  const [search, setSearch] = useState("");
  const [date, setDate] = useState(null);
  const [data, setData] = useState(null);
  const [openGift, setOpenGift] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [selected, setSelected] = useState(null);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const vouchers = useSelector(vouchersSelector);
  const user = useSelector(userSelector);
  console.log("vouchers", vouchers);
  // -------------------------- FUNCTION --------------------------
  const handleChangeDate = (date) => {
    setDate(date);
  };

  const handleChange = (value) => {
    let data = vouchers || [];
    if (value !== "all") {
      data = data?.filter((item) => item?.source === value);
    }
    setData(data);
  };
  // -------------------------- EFFECT --------------------------
  //snap vouchers
  useEffect(() => {
    if (packageId !== "" && branchId !== "") {
      dispatch(snapVouchersByPackageId({ packageId, branchId }));
    }

    return () => dispatch(unSnapVoucher());
  }, [packageId, branchId]);

  //Load the data
  useEffect(() => {
    if (vouchers) {
      setData(vouchers);
    }
  }, [vouchers]);

  //filter
  useEffect(() => {
    let data = vouchers || [];
    const from = date ? date[0] : "";
    const to = date ? date[1] : "";

    if (search !== "") {
      data = data?.filter((item) => {
        const lowersearch = search?.toLowerCase();
        const code = item?.code?.toLowerCase();
        const valids = code?.includes(lowersearch);

        return valids;
      });
    }

    //date
    if (from !== "" && to !== "") {
      data = data?.filter((item) => {
        const createAt = item?.createAt && moment(item?.createAt?.toDate());
        const validFrom = createAt >= from;
        const validTo = createAt <= to;
        return validFrom && validTo;
      });
    }

    setData(data);
  }, [date, search]);

  // -------------------------- RENDER --------------------------
  const renderBar = () => {
    return (
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          {renderGiveAway()}
        </Col>
        <Col align="right" lg={12} md={12} sm={24} xs={24}>
          <RangePicker onChange={handleChangeDate} />
        </Col>
      </Row>
    );
  };

  const renderGiveAway = () => {
    return (
      <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
        <span style={{ marginRight: 20 }}>
          <Button
            type="primary"
            onClick={() => setOpenGift(true)}
            style={{ width: 150 }}
          >
            Give away
          </Button>
        </span>
        <SearchVoucher search={search} setSearch={setSearch} />
      </div>
    );
  };

  const renderSegmented = () => {
    const total = SumObject(data);

    return (
      <Row style={{ marginTop: 20 }}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <Segmented
            defaultValue={"all"}
            size="middle"
            options={VOUCHER_STATUS}
            onChange={handleChange}
          />
        </Col>
        <Col align="right" lg={12} md={12} sm={24} xs={24}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              fontWeight: "bold",
            }}
          >
            Total {data?.length || 0} vouchers |
            <h3 style={{ margin: 0, marginLeft: 20 }}>$ {total}</h3>
          </div>
        </Col>
      </Row>
    );
  };

  const renderList = () => {
    const sort = sortData(data);
    return (
      <VoucherList
        data={sort}
        setOpen={setOpenDetail}
        setSelected={setSelected}
      />
    );
  };

  const renderModal = () => {
    return (
      <>
        <DialogSendVoucher
          open={openGift}
          setOpen={setOpenGift}
          user={user}
          vouchers={vouchers}
        />
        <DialogVoucherDetail
          data={selected}
          open={openDetail}
          setOpen={setOpenDetail}
        />
      </>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row className="section-search">
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderBar()}
      </Col>
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderSegmented()}
      </Col>
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderList()}
      </Col>
      {renderModal()}
    </Row>
  );
};

export default SectionSearch;

const SumObject = (Array) => {
  const newArray = Array?.map((item) => item?.balance);
  const total = newArray?.reduce((a, b) => a + b, 0);

  return total;
};

const sortData = (data) => {
  const newSort = data?.sort((a, b) => b?.createAt - a?.createAt);
  return newSort;
};
